/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BDUpdateItem
 */
export interface BDUpdateItem {
    /**
     * 
     * @type {string}
     * @memberof BDUpdateItem
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BDUpdateItem
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BDUpdateItem
     */
    newValue?: string | null;
}

export function BDUpdateItemFromJSON(json: any): BDUpdateItem {
    return BDUpdateItemFromJSONTyped(json, false);
}

export function BDUpdateItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): BDUpdateItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'oldValue': !exists(json, 'oldValue') ? undefined : json['oldValue'],
        'newValue': !exists(json, 'newValue') ? undefined : json['newValue'],
    };
}

export function BDUpdateItemToJSON(value?: BDUpdateItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'oldValue': value.oldValue,
        'newValue': value.newValue,
    };
}


